/**
 * @file   number.filter.js
 * @author wangzian<wangzian@baidu.com>
 */

export function priceInt(cents) {
    if (cents < 100) {
        cents = cents >= 10 ? '0' + cents : '00' + cents;
    }
    cents += '';
    cents = cents.slice(0, -2);
    return cents;
}

function time(s, md) {
    const dt = new Date(s * 1000);
    const y = dt.getFullYear();
    let m = dt.getMonth() + 1;
    let d = dt.getDate();

    if (m <= 9) {
        m = '0' + m;
    }
    if (d <= 9) {
        d = '0' + d;
    }
    if (md) {
        return `${m}-${d}`;
    }
    return `${y}-${m}-${d}`;
}

/**
 * 时间戳格式转化
 * @param {timestamp} time
 * @param {string} fmt 时间格式
 * @return {string} 时间字符串
*/
export function formatTime(time, fmt = 'yyyy-MM-dd hh:mm') {
    const toTwo = n => (+n < 10 ? '0' + n : n + '');

    let oDate;
    if ((time + '').length === 10) {
        oDate = new Date(parseInt(time, 10) * 1000);
    }
    else {
        oDate = new Date(parseInt(time, 10));
    }

    const date = {
        'y+': oDate.getFullYear(),
        'M+': oDate.getMonth() + 1,
        'd+': oDate.getDate(),
        'h+': oDate.getHours(),
        'm+': oDate.getMinutes(),
        's+': oDate.getSeconds(),
        'S': oDate.getMilliseconds(),
        'q+': Math.ceil((oDate.getMonth() + 1) / 3)
    };

    let result = '';
    let value = '';

    for (let attr in date) {
        if (new RegExp('(' + attr + ')').test(fmt)) {
            result = RegExp.$1;
            value = date[attr] + '';
            fmt = fmt.replace(result, result.length === 1 ? value
                : (attr === 'y+' ? value.substring(4 - result.length) : toTwo(value)));
        }
    }
    return fmt;
}

function addZero(num) {
    num = parseInt(num, 10);
    return num <= 9 ? '0' + num : num;
}

/**
 * 发布时间格式转化
 * @param  {string} s 毫秒表示的发布时间
 * @return {string} 字符串描述的发布时间
 */
export function getPublishTime(s) {
    let pastHour = Math.floor(((new Date()).getTime() - s) / 3600000);
    if (pastHour < 1) {
        return '刚刚';
    }
    else if (pastHour >= 1 && pastHour < 24) {
        return `${pastHour}小时前`;
    }
    else if (pastHour >= 24 && pastHour < 72) {
        let pastDay = Math.floor(pastHour / 24);
        return `${pastDay}天前`;
    }
    else if (pastHour >= 72 && pastHour < 8760) {
        return time(s / 1000, true);
    }

    return time(s / 1000);

};

/**
 * 格式化价格, 分转化为元
 * @param  {string} cents 分
 * @param  {string} strictMode 严格模式
 * @return {string} 价格转化为元
 */
export function formatPrice(cents, strictMode = true) {
    if (cents < 100) {
        cents = cents >= 10 ? '0' + cents : '00' + cents;
    }

    cents += '';

    // 非严格模式下，价格后头如果是.00则不展示
    if (strictMode || parseInt(cents.slice(-2), 10) > 0) {
        cents = cents.slice(0, -2) + '.' + cents.slice(-2);
    }
    else {
        cents = cents.slice(0, -2);
    }

    return cents;
}

function handlePrecision(num) {
    let centsTail1 = num.slice(-2, -1);
    let centsTail2 = num.slice(-1);

    if (centsTail1 === '0' && centsTail2 === '0') {
        num = num.slice(0, -2);
    }
    else if (centsTail2 === '0' && centsTail1 !== '0') {
        num = num.slice(0, -2) + '.' + num.slice(-2, -1);
    }
    else {
        num = num.slice(0, -2) + '.' + num.slice(-2);
    }

    return num;
}

function getPriceTypeInfo(cents) {
    let fixedCents = String(cents);
    let unit = '';

    // 超过10万时单位为万元，保留小数点后面两位
    if (cents >= 10000000) {
        unit = '万';
        fixedCents = fixedCents.slice(0, -4);
    }
    else if (cents < 100) {
        fixedCents = cents >= 10 ? '0' + fixedCents : '00' + fixedCents;
    }
    fixedCents = handlePrecision(fixedCents);

    return {num: fixedCents, unit: unit};
}

/**
 * 字符串长度切割
*/
export function ellipsis(str, limit = 0, tail = '...') {
    let result = '';
    if (typeof str !== 'string') {
        str += '';
    }

    function getByteLen(str) {
        if (typeof str !== 'string') {
            str += '';
        }
        return str.replace(/[^\x00-\xff]/g, 'aa').length;
    }

    limit *= 2;
    if (limit >= getByteLen(str)) {
        return str;
    }

    for (let i = 0; i < str.length; i++) {
        const char = str.charAt(i);
        if (getByteLen(result + char) > limit) {
            break;
        }
        result += char;
    }

    return result + tail;
}

export default {
    /**
     * 格式化价格
     * @function price
     * @param  {number} cents 分
     * @return {string} version 返回app的版本号
     * @example
     * price(123, false)
     */

    price(cents, strictMode = true) {
        if (cents < 100) {
            cents = cents >= 10 ? '0' + cents : '00' + cents;
        }

        cents += '';

        // 非严格模式下，价格后头如果是.00则不展示
        if (strictMode || parseInt(cents.slice(-2), 10) > 0) {
            cents = cents.slice(0, -2) + '.' + cents.slice(-2);
        }
        else {
            cents = cents.slice(0, -2);
        }

        return cents;
    },

    getPriceNum(cents) {
        return getPriceTypeInfo(cents).num + getPriceTypeInfo(cents).unit;
    },

    /**
    * 时间格式转化
    * @param  {string} s 毫秒表示的时间
    * @return {string} year/month/date 表示的时间
    */

    ms2ymd(s) {
        const timeObj = new Date(s);
        const year = timeObj.getFullYear();
        const month = timeObj.getMonth() + 1;
        const day = timeObj.getDate();
        let result = `${year}/${month}/${day}`;

        return result;
    },

    /**
     * 时间戳距离现在的时长格式化(常用于倒计时)
     * @param {string} s 毫秒表示的时间
     * @return {string} d天 h:m:s.[100ms]
     */

    ms2deltaFormated(s) {
        let delta = s;
        let pastDay = Math.floor(delta / 86400000);
        delta %= 86400000;
        let pastHour = addZero(Math.floor(delta / 3600000));
        delta %= 3600000;
        let pastMinute = addZero(Math.floor(delta / 60000));
        delta %= 60000;
        let pastSecond = addZero(Math.floor(delta / 1000));
        delta %= 1000;
        let pastHundredMS = Math.floor(delta / 100);
        return `${pastDay}天 ${pastHour}:${pastMinute}:${pastSecond}.${pastHundredMS}`;
    },

    /**
     * 时间戳距现在时长格式化(用于时分秒倒计时)
     * @param {string} s 毫秒表示时间
     * @return {string} h:m:s
    */
    // FIXME 后续使用类似功能，提取公共代码改造
    ms2time(s) {
        let delta = s;
        const pastHour = addZero(Math.floor(delta / 3600000));
        delta %= 3600000;
        const pastMinute = addZero(Math.floor(delta / 60000));
        delta %= 60000;
        const pastSecond = addZero(Math.floor(delta / 1000));
        return `${pastHour}:${pastMinute}:${pastSecond}`;
    }
};
